export default "__VITE_ASSET__BdqQJxTg__"